<template>
    <navbar
            position="fixed"
            type="primary"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto"
    >
        <template slot-scope="{ toggle, isToggled }">
            <router-link class="navbar-brand" to="/">
                <img alt="svgImg"
                     src="data:image/svg+xml;base64,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"/>
                Signitive
            </router-link>
        </template>
        <template slot="navbar-menu">
            <li class="nav-item">
                <a
                        class="nav-link"
                        href="#"
                        target="_blank"
                >
                    <!--                    <i class="now-ui-icons design_image"></i>-->
                    <p>Home</p>
                </a>
            </li>
            <drop-down
                    tag="li"
                    title="About"
                    class="nav-item"
            >
                <nav-link to="#">
                    <!--                    <i class="now-ui-icons business_chart-pie-36"></i> -->
                    Who we are
                </nav-link>
                <a
                        class="dropdown-item"
                        href="#contact"
                >
                    <!--                    <i class="now-ui-icons design_bullet-list-67"></i> -->
                    Contact Us
                </a>
            </drop-down>
            <drop-down
                    tag="li"
                    title="Services"
                    icon="now-ui-icons design_app"
                    class="nav-item"
            >
                <!--                <nav-link to="/landing">-->
                <!--                    <i class="now-ui-icons education_paper"></i> Landing-->
                <!--                </nav-link>-->
                <!--                <nav-link to="/login">-->
                <!--                    <i class="now-ui-icons users_circle-08"></i> Login-->
                <!--                </nav-link>-->
                <a class="dropdown-item" href="#services">
                    <i class="now-ui-icons education_paper"></i>
                    IT Consulting
                </a>
            </drop-down>
            <!--            <li class="nav-item">-->
            <!--                <a-->
            <!--                        class="nav-link btn btn-neutral"-->
            <!--                        href="https://www.creative-tim.com/product/vue-now-ui-kit-pro"-->
            <!--                        target="_blank"-->
            <!--                >-->
            <!--                    <i class="now-ui-icons arrows-1_share-66"></i>-->
            <!--                    <p>Upgrade to PRO</p>-->
            <!--                </a>-->
            <!--            </li>-->

            <li class="nav-item">
                <a
                        class="nav-link"
                        rel="tooltip"
                        title="Follow us on Twitter"
                        data-placement="bottom"
                        href="#"
                        target="_blank"
                >
                    <i class="fab fa-twitter"></i>
                    <p class="d-lg-none d-xl-none">Twitter</p>
                </a>
            </li>
            <li class="nav-item">
                <a
                        class="nav-link"
                        rel="tooltip"
                        title="Like us on Facebook"
                        data-placement="bottom"
                        href="#"
                        target="_blank"
                >
                    <i class="fab fa-facebook-square"></i>
                    <p class="d-lg-none d-xl-none">Facebook</p>
                </a>
            </li>
            <li class="nav-item">
                <a
                        class="nav-link"
                        rel="tooltip"
                        title="Follow us on Youtube"
                        data-placement="bottom"
                        href="#"
                        target="_blank"
                >
                    <i class="fab fa-youtube"></i>
                    <p class="d-lg-none d-xl-none">Youtube</p>
                </a>
            </li>
        </template>
    </navbar>
</template>

<script>
    import {DropDown, NavbarToggleButton, Navbar, NavLink} from '@/components';
    import {Popover} from 'element-ui';

    export default {
        name: 'main-navbar',
        props: {
            transparent: Boolean,
            colorOnScroll: Number
        },
        components: {
            DropDown,
            Navbar,
            NavbarToggleButton,
            NavLink,
            [Popover.name]: Popover
        }
    };
</script>

<style scoped></style>
